import { createRouter, createWebHistory } from 'vue-router'

// Backwards-compat shim for agents with old bookmarks containing hash URLs
// (e.g. https://.../#/accommodation). Browsers never send the fragment to the
// server so this can only be handled client-side. Must run before the router
// resolves any initial navigation. Predates the Auth0 Passwordless pivot —
// still needed for the hash → path history migration to honour old bookmarks.
if (window.location.hash.startsWith('#/')) {
  const newPath = window.location.hash.slice(1) + window.location.search
  window.history.replaceState(null, '', newPath)
}

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ top: 0 }),
  routes: [],
})

export default router
